// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"cfbf107b299c1a637384","453":"5d9f994894aacaa9f7eb"}[chunkId] + ".js";
};